import React, { Component } from "react"

class OurSkills extends Component {
  render() {
    return (
      <section id="our-skills">
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="section-header-pic">
                <h2 className="m-0">Our Products</h2>
              </div>
            </div>
            <div className="col-12 pt-3 about-pb">
              <p className="lead text-white">
                We trust our developers and designers that's why we successed in
                developing
                <br />
                the following amazing successful products.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-sm-12">
              <div className="progress-wrap">
                <h3>Web Developement</h3>
                <div className="progress">
                  <div className="progress-bar progress-bar-striped color1 web-development">
                    <span className="bar-width web-development">95%</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <div className="progress-wrap">
                <h3>Graphic Designing</h3>
                <div className="progress">
                  <div className="progress-bar progress-bar-striped color2 graphic-design">
                    <span className="bar-width graphic-design">90%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-lg-5">
            <div className="col-lg-6 col-sm-12">
              <div className="progress-wrap">
                <h3>App Developement</h3>
                <div className="progress">
                  <div className="progress-bar progress-bar-striped color3 app-development">
                    <span className="bar-width app-development">85%</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <div className="progress-wrap">
                <h3>SEO Marketing</h3>
                <div className="progress">
                  <div className="progress-bar progress-bar-striped color4 seo-marketing">
                    <span className="bar-width seo-marketing">75%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default OurSkills
